import { cancelScheduledDelivery } from './cancelScheduledDelivery';
import { createScheduledDelivery } from './createScheduledDelivery';
import { getGourmetScheduledOrders } from './getGourmetScheduledOrders';
import { getScheduledOrderCalendarRecords } from './getScheduledOrderCalendarRecords';
import { updateScheduledDelivery } from './updateScheduledDelivery';

export const scheduledDeliveryService = {
  cancelScheduledDelivery,
  createScheduledDelivery,
  getGourmetScheduledOrders,
  getScheduledOrderCalendarRecords,
  updateScheduledDelivery,
};
